module.exports = __webpack_public_path__ + "images/help/video-me-small-ed15a4dcab4ea1569db279ac0130efa4.png";